<div class="wrapper">
    <app-header></app-header>
    <div class="main-content">
        <router-outlet />
    </div>
    <app-footer></app-footer>
</div>